module.exports = __webpack_public_path__ + "img/footballBanner_460.69c2444c.png";